import { Link } from "react-router";
import { Permission } from "@/auth/access-permissions";
import type { Comparable } from "@/components/comparison/comparable";
import { useCompanyComparisonStore, type CompanyComparisonSelection } from "@/stores/company-comparison-store";
import { CompanyLogo } from "./CompanyLogo";
import { CompanyComparisonPicker } from "./CompanyComparisonPicker";

export const companyComparable: Comparable<CompanyComparisonSelection> = {
  kind: "company", permission: Permission.CompareCompanies, path: "/c/compare", searchPath: "/extended-search?type=COMPANY", messages: {
    tools: "company.compare.tools",
    remove: "company.compare.remove",
    select: "company.compare.select",
    removeDescription: "company.compare.removeDescription",
    selectDescription: "company.compare.selectDescription",
    count: "company.compare.count",
    full: "company.compare.full",
    removeName: "company.compare.removeName",
    title: "company.compare.title",
    addItem: "company.compare.addItem",
    denied: "company.compare.denied",
    empty: "company.compare.empty",
    search: "company.compare.search",
    loading: "company.compare.loading",
    retry: "company.compare.retry",
    unavailable: "company.compare.unavailable",
  },
  useSelection: useCompanyComparisonStore,
  identity: (company) => <Link to={`/c/${company.id}`} className="inline-flex max-w-48 items-center gap-2 rounded-full py-1 pl-1 pr-2 text-smycles-label focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-ui"><CompanyLogo name={company.name} logo={company.logo} size="compact" /><span className="truncate">{company.name}</span></Link>,
  picker: (props) => <CompanyComparisonPicker {...props} />,
};
